import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

function HeritageGatewayMonumentPeriodFilter({
  facets,
  setFilter,
  removeFilter,
  filters,
}) {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="monumentPeriod"
      filters={filters}
      id="monument-period"
      label="Period"
      removeFilter={removeFilter}
      setFilter={setFilter}
      sort={true}
    />
  );
}

export default withSearch(({ setFilter, removeFilter, filters, facets }) => ({
  facets,
  setFilter,
  removeFilter,
  filters,
}))(HeritageGatewayMonumentPeriodFilter);
